import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 cursor-pointer">
              丫丫影院
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              最新电影不缓冲，最新电视剧流畅在线看。丫丫影院提供高清免费影视资源，更新快，不卡顿，为您打造极致观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">影视分类</h4>
            <div className="flex flex-wrap gap-2">
              {categories.filter(c => c.key !== 'all').map((cat) => (
                <Link
                  key={cat.key}
                  to={`/category/${cat.key}`}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
            <div className="space-y-2">
              <Link to="/detail/m1" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">流浪地球3</Link>
              <Link to="/detail/m2" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">哪吒之魔童闹海</Link>
              <Link to="/detail/tv1" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">狂飙</Link>
              <Link to="/detail/tv2" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">庆余年第二季</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="space-y-2">
              <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link>
              <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">用户口碑</Link>
              <Link to="/about" className="block text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link>
            </div>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 丫丫影院 YAYA.TV - 最新电影不缓冲，最新电视剧流畅在线看
          </p>
          <p className="text-xs text-background-500">
            本站所有资源均来自网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}